// global.$ = global.jQuery = require('jquery');

import $ from "jquery";
// import Popper from 'popper.js';
// import Popper from 'popper.js/dist/umd/popper.min.js';
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Import the bundle, which includes Popper.js

window.$ = $;
window.jQuery = $;
// window.Popper = Popper;

require("datatables.net-bs4");
// require('./bootstrap');
require("owl.carousel");

$("#owl-client").owlCarousel({
    loop: true,
    margin: 20,
    dots: false,
    autoplay: true,
    responsive: {
        0: {
            items: 3,
        },
        600: {
            items: 4,
        },
        1000: {
            items: 5,
        },
    },
});

$("#owl-about").owlCarousel({
    loop: true,
    margin: 20,
    dots: false,
    autoplay: true,
    responsive: {
        0: {
            items: 2,
        },
        600: {
            items: 3,
        },
        1000: {
            items: 5,
        },
    },
});

$("#owl-services").owlCarousel({
    loop: true,
    margin: 15,
    dots: false,
    autoplay: true,
    responsive: {
        0: {
            items: 3,
        },
        600: {
            items: 5,
        },
        1000: {
            items: 6,
        },
    },
});

$("#owl-review").owlCarousel({
    loop: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
        0: {
            items: 1,
        },
        768: {
            items: 1,
        },
        1024: {
            items: 1,
        },
    },
});

$("#owl-offer").owlCarousel({
    loop: false,
    margin: 5,
    autoplay: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    dots: false,
    nav: true, // <--- aktifkan tombol navigasi
    navText: [
        '<button class="btn-prev"><i class="fa fa-chevron-left"></i></button>',
        '<button class="btn-next"><i class="fa fa-chevron-right"></i></button>',
    ],
    responsive: {
        0: {
            items: 1,
        },
        768: {
            items: 1,
        },
        1024: {
            items: 1,
        },
    },
});
